import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SectionTitleComponent } from '../../../components/section-title/section-title.component';
import { TopFailure } from '../../models/dashboard.model';

@Component({
  selector: 'app-top-failures',
  imports: [TranslatePipe, RouterLink, SectionTitleComponent],
  templateUrl: './top-failures.component.html',
  styleUrl: './top-failures.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopFailuresComponent {
  failures = input.required<TopFailure[]>();

  protected readonly headingId = 'top-failures-heading';

  protected detailLink(failure: TopFailure): unknown[] | null {
    if (!failure.projectId) {
      return null;
    }
    return ['/projects', failure.projectId, 'test-cases', failure.testCaseId, 'edit'];
  }
}
